<header>
    <div class="wrap">        
        <div class="text p-3">
            <h3>{{ 'popins.storeStock.title' | translate }}</h3>
            <h3 class="ean">{{ ean }}</h3>
        </div>

        <div class="text p-3" *ngIf="storeStock.length === 0">
            <p class="info">
                {{ 'popins.storeStock.noStore' | translate}}
            </p>
        </div>

        <div class="header-actions">
            <button class="close" (click)="returnToProductList()" title="{{ 'generic.close' | translate }}">
                <span class="icon-view-close" aria-hidden="true">
                    <svg>
                        <use xlink:href="assets/img/icons.svg#icon-view-close"></use>
                    </svg>
                </span>
                <span>{{ 'generic.close' | translate }}</span>
            </button>
        </div>
    </div>
</header>
<div class="main">
    <div class="inner-content" *ngIf="storeStock.length > 0">
        <div class="text">
            <table class="stock-table">
                <tbody>
                    <tr>
                        <td>{{ 'popins.storeStock.column.storeName' | translate }}</td>
                        <td>{{ 'popins.storeStock.column.storeCode' | translate }}</td>
                        <td>{{ 'popins.storeStock.column.value' | translate }}</td>
                    </tr>
                    <tr *ngFor="let store of storeStock">
                        <td  [ngClass]="{'gray-text': store.stock === 0}">{{ store.storeName }}</td>
                        <td  [ngClass]="{'gray-text': store.stock === 0}">{{ store.storeId }}</td>
                        <td  [ngClass]="{'gray-text': store.stock === 0}">{{ store.stock }}</td>
                    </tr>
                </tbody>                
            </table>
        </div>
    </div>    
</div>